<div>
  <p class="text-xs border-l-4 border-chathams-blue-600 pl-1">{{ 'createScreen.note' | translate }}</p>
  <p class="text-xs">{{ label | translate }}</p>
</div>
